import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';
import notify from './notify';

export const columnFilterLang = { no_filter: 'Aucun', contain: 'Contiens', not_contain: 'Ne contiens pas', equal: 'Egale', not_equal: 'Différent', start_with: 'Commence par', end_with: 'Termine par', greater_than: 'Supérieur à', greater_than_equal: 'Sup. ou égale à', less_than: 'Inférieur à', less_than_equal: 'Inf. ou égale à', is_null: 'Est null', is_not_null: 'Non null' }

export const truncate = (text, maxLength = 1000) => {
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text
}

export const backError = (error, defaultMessage = "Une erreur est survenue") => {
  if (!error) {
    return notify(defaultMessage);
  }
  if (error.response?.status === 422 && error.response.data?.errors) {
    const errors = error.response.data.errors;

    let errorMessages = [];
    for (const field in errors) {
      errorMessages.push(...errors[field]);
    }

    const htmlMessage = `
            <div style="text-align: left;">
                <div style="margin-bottom: 8px; font-weight: bold;">Erreurs de validation :</div>
                <ul style="margin: 0; padding-left: 20px;">
                    ${errorMessages.map(msg => `<li>${msg}</li>`).join('')}
                </ul>
            </div>
        `;
    notify(htmlMessage)
  }

}


async function loadTemplate(url) {
  const response = await fetch(url);
  const arrayBuffer = await response.arrayBuffer();
  return arrayBuffer;
}

export async function generateWordDoc(data) {
  const content = await loadTemplate('/template.docx');
  const zip = new PizZip(content);
  const doc = new Docxtemplater(zip, {
    paragraphLoop: true,
    linebreaks: true,
  });

  const transfData = transformerDonneesRapport(data)
  doc.setData(transfData);

  try {
    doc.render();
    const blob = doc.getZip().generate({
      type: 'blob',
      mimeType:
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    });

    saveAs(blob, 'rapport.docx');
  } catch (error) {
    console.error('Erreur lors du rendu du document:', error);
  }
}

function transformerDonneesRapport(data) {
  return {
    periode: data.paragraphe_one.periode,
    titre_trimestre: data.paragraphe_one.titre_trimestre,

    one_total: data.array_one.total,
    one_date: data.array_one.date,
    one_web: data.array_one.web,
    one_call: data.array_one.call_center,
    one_physique: data.array_one.physique,
    one_paragraph: data.sub_paragraphe_one,

    two_sans: data.array_two.sans_suite,
    two_transf: data.array_two.structure,
    two_interne: data.array_two.interne,
    two_total: data.array_two.total,
    two_sub: data.sub_paragraphe_two,

    three_paragraph: data.paragraphe_three,
    three_tables: data.array_three.map((item, index) => ({
      id: index + 1,
      structure: item.structure,
      description: item.description,
      observations: item.commentaire || ""
    })),

    four_paragraph: data.paragraphe_four,
    four_tables: data.array_four.map((item, index) => ({
      id: index + 1,
      description: item.description,
      structure: item.structure,
      observations: item.observations || ""
    }))
  };
}

